/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */
export enum ReportScreenEnum {
  welcome = "welcome",
  registration = "registration",
  damagelocator = "damagelocator",
  overviewimage = "overviewimage",
  componentimage = "componentimage",
  damagedetail = "damagedetail",
  mileage = "mileage",
  message = "message",
  contactdetails = "contactdetails",
  simplecontact = "simplecontact",
  daterequest = "daterequest",
  closing = "closing",
  reportType = "reportType",
  witness = "witness",
  liabilityselector = "liabilityselector",
  vinimage = "vinimage",
  tuevimage = "tuevimage",
  tireimage = "tireimage",
  additionalimage = "additionalimage",
  accidentdetails = "accidentdetails",
  accidentopponents = "accidentopponents",
  responsibleparty = "responsibleparty",
  driverslicense = "driverslicense",

  /**
   * thg screens
   */
  thghome = "thghome",
  thgzip = "thgzip",
  thgimpactselector = "thgimpactselector",
  thgimpactselectortrees = "thgimpactselectortrees",
  thgImpactSelectorWithCustomerAccount = "thgImpactSelectorCustomerAccount",
  thgImpactSelectorOnlyCustomerAccount = "thgImpactSelectorOnlyCustomerAccount",
  thgimpactfactor = "thgimpactfactor",
  thgcontact = "thgcontact",
  thgYearSelection = "thgYearSelection",
  thgregistration = "thgregistration",
  thgregistrationat = "thgregistrationat", // Austria screen for the registraion
  thgregistrationfront = "thgregistrationfront",
  thgpassword = "thgpassword",
  thgclosing = "thgclosing",
  thgcustomerdetails = "thgcustomerdetails",
  thgImpactSelectorOnlyPayout = "thgImpactSelectorOnlyPayout",
  thgImpactSelectorOnlyCustomerAccountAndPayout = "thgImpactSelectorOnlyCustomerAccountAndPayout",

  /**
   * repareo screens
   */
  REPAREO_HOME = "repareohome",
  REPAREO_DATE_REQUEST = "repareodaterequest",
  REPAREO_CLOSING = "repareoclosing"
}
